import React from 'react';
import { EditModifierGroupState } from './editModifierGroupState/EditModifierGroupState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const EditModifierGroupPageV2: React.FC = () => {
	return (
		<EditModifierGroupState>
			<Forms />
			<ModalWindows />
		</EditModifierGroupState>
	);
};
